import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { browserHistory } from '../../helpers/history';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as Service from '../../services/organizationaccountemail.service';
import { getAllByOrganizationIdSelectionModel as getAllAddressesByOrganizationIdSelecionModel } from '../../services/address.service'
import { getAllSelectionModelCanCreateCalledByOrganizationId as getAllOrganizationCategoryCanCreateCAlledByOrganizationId } from '../../services/organizationcategory.service'
import { getAllSelectionModel as getAllStatusSelectionModel } from '../../services/status.service'
import { getAllSelectionModel as getAllTypeSelectionModel } from '../../services/type.service'
import { PapiroConsole } from '../../utils/papiroConsole';
import MailSending from "src/components/mailsending";
import MailReceiving from "src/components/mailreceiving";
import ProviderSelection from "src/components/providerselection";
import { Tab as RTab, Tabs as RTabs, TabList as RTabList, TabPanel as RTabPanel } from 'react-tabs';

class OrganizationAccountEmailRegistration extends Component {

  constructor(props) {
    super(props);

    const { userSession, organizations } = this.props;

    this.fromProps = false
    if (this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
      this.fromProps = true

    this.globalAdm = false;
    this.isClient = true;
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
    });


    this.initialState = {
      createdUser: userSession.user.id,
      createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
      active: false,
      organizationid: organizations.organization.id,
      providertype: 0,
      name: '',
      addressId: 0,
      organizationCategoryId: 0,
      statusId: 0,
      typeId: 0,
      addressemail: '',
      serverSend: '',
      fromMailSend: '',
      portSend: '',
      cryptotypeSend: '',
      passwordSend: '',
      userSend: '',
      authenticationrequiredSend: true,
      authenticationmethodtypeIdSend: '',
      serverReceived: '',
      fromMailReceived: '',
      portReceived: '',
      cryptotypeReceived: '',
      passwordReceived: '',
      userReceived: '',
      authenticationrequiredReceived: true,
      authenticationmethodtypeIdReceived: '',
      emailtest: '',
    };

    var orgList = [];
    orgList.push(organizations.organization);

    this.state = {
      item: this.initialState,
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrgList: orgList,
      ProviderList: [],
      AuthTypeList: [],
      CryptoList: [],
      CloudTypeList: [],
      AuthenticationList: [],
      addessesList: [],
      organizationCategoriesList: [],
      statusList: [],
      typesList: [],
      customProvider: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.getAllAddressesByOrganizationIdSelecionModel = this.getAllAddressesByOrganizationIdSelecionModel.bind(this)
    this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId = this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId.bind(this)
    this.getAllStatusSelectionModel = this.getAllStatusSelectionModel.bind(this)
    this.getAllTypeSelectionModel = this.getAllTypeSelectionModel.bind(this)
    this.setCustomProvider = this.setCustomProvider.bind(this)
  }

  componentDidMount() {
    this.getAllAddressesByOrganizationIdSelecionModel()
    this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId()
    this.getAllStatusSelectionModel()
    this.getAllTypeSelectionModel()
    this.getProvider();
    this.getAuthentication();
    this.getCrypto();
    this.getAuthType();
    this.getCloudType()
  };

  getAllAddressesByOrganizationIdSelecionModel = async _ => {
    let result = await getAllAddressesByOrganizationIdSelecionModel(this.state.item.organizationid)
    if (result && result.success) {
      this.setState({ loading: false, addessesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  setCustomProvider = async (value) => {
    const { intl } = this.props
    this.setState({ customProvider: value })

    let client_id = ''
    if (value == 1) {
      await Api.get('/token/oauth/gmail')
        .then(result => {
          if (result && result.data && result.data.success == true) {
            client_id = result.data.data
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })
      if (client_id.length > 0) {
        let redirect_uri = `https%3A%2F%2F${document.location.host.replace(':', '%3A')}%2Fpt%2Fauthorize`;
        let scope = "https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.readonly https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.modify";
        //state = tela a ser redirecionada, id da org, tab da tela de edição da org
        let state = `organization-edit ${this.state.item.organizationid} 14 gmail`;
        var url = `https://accounts.google.com/o/oauth2/auth?access_type=offline&client_id=${client_id}&prompt=select_account+consent&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=${state}`;
        PapiroConsole.log(redirect_uri)
        PapiroConsole.log("redirect_uri")
        document.location.href = url;
      }
    } else if (value == 2) {

      let url = ''

      await Api.get('/token/oauth/microsoft')
        .then(result => {
          if (result && result.data && result.data.success == true) {
            url = result.data.data
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
          }
        })
        .catch(err => {
          const intl = this.props.intl
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })
      if (url.length > 0) {
        PapiroConsole.log(url)
        PapiroConsole.log('microsoft url')
        let state = `organization-edit ${this.state.item.organizationid} 14 microsoft`;
        url += `&state=${state}`;
        document.location.href = url;
      }
    } else if (value == 3) {
      this.setState((prevState) => ({
        ...prevState,
        item: {
          ...prevState.item,
          cloudType: 1,
          cloudTypeReceive: 1,
        }
      }))
    }

  }

  getAllOrganizationCategoryCanCreateCAlledByOrganizationId = async _ => {
    let result = await getAllOrganizationCategoryCanCreateCAlledByOrganizationId(this.state.item.organizationid)
    if (result && result.success) {
      this.setState({ loading: false, organizationCategoriesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  getAllStatusSelectionModel = async _ => {
    let result = await getAllStatusSelectionModel()
    if (result && result.success) {
      this.setState({ loading: false, statusList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  getAllTypeSelectionModel = async _ => {
    let result = await getAllTypeSelectionModel()
    if (result && result.success) {
      this.setState({ loading: false, typesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  async getOrg() {
    this.setState({ loading: true });
    var result = await Service.getOrg();
    if (result.success) {
      this.setState({ loading: false, OrgList: result.data });

    } else {
      this.setState({
        loading: false, openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  };
  async getProvider() {
    this.setState({ loading: true });
    var result = [];
    result.push({ id: '1', name: 'Google' });

    this.setState({ loading: false, ProviderList: result });
  };
  async getAuthentication() {
    this.setState({ loading: true });
    var result = [];
    result.push({ id: '1', name: 'DKIM' });

    this.setState({ loading: false, AuthenticationList: result });
  };
  async getCrypto() {
    this.setState({ loading: true });
    var result = [];
    result.push({ id: '1', name: 'SSL' });

    this.setState({ loading: false, CryptoList: result });
  };

  async getAuthType() {
    var result = []
    result.push({ id: '1', name: 'Default' })
    result.push({ id: '2', name: 'Oauth2' })
    this.setState({ AuthTypeList: result })
  }

  async getCloudType() {
    var result = []
    result.push({ id: '1', name: 'Custom' })
    result.push({ id: '2', name: 'GoogleMail' })
    result.push({ id: '3', name: 'MicrosoftOutlook' })
    result.push({ id: '4', name: 'MicrosoftHotmail' })
    result.push({ id: '5', name: 'Yahoo' })
    this.setState({ CloudTypeList: result })
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }));
  };

  handleSubmit = async e => {

    const intl = this.props.intl;
    e.preventDefault();

    if (this.state.item.serverSend == null || this.state.item.serverSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.server.field" })
      });
      return false
    }
    if (this.state.item.fromMailSend == null || this.state.item.fromMailSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: `O campo 'E-mail' em 'Informações de Envio' é obrigatório`
      });
      return false
    }
    if (this.state.item.portSend == null || this.state.item.portSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.port.field" })
      });
      return false
    }
    if (this.state.item.cryptotypeSend == null || this.state.item.cryptotypeSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.crypto.field" })
      });
      return false
    }
    if (this.state.item.userSend == null || this.state.item.userSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.user.field" })
      });
      return false
    }
    if (this.state.item.passwordSend == null || this.state.item.passwordSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.password.field" })
      });
      return false
    }

    if (this.state.item.serverReceived == null || this.state.item.serverReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.server.field.info" })
      });
      return false
    }
    if (this.state.item.fromMailReceived == null || this.state.item.fromMailReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: `O campo 'E-mail' em 'Informações de Recebimento' é obrigatório`
      });
      return false
    }
    if (this.state.item.portReceived == null || this.state.item.portReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.port.field.info" })
      });
      return false
    }
    if (this.state.item.cryptotypeReceived == null || this.state.item.cryptotypeReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.crypto.field.info" })
      });
      return false
    }
    if (this.state.item.userReceived == null || this.state.item.userReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.user.field.info" })
      });
      return false
    }
    if (this.state.item.passwordReceived == null || this.state.item.passwordReceived.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.password.field.info" })
      });
      return false
    }

    this.setState({ loading: true });

    if (this.state.item.responseemailisnewcalled === true && this.state.item.accompanimentcalledforresponseemail === true) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.email.answer.is.new.called" })

      });
    } else {
      let data = new FormData();

      for (let key in this.state.item) {
        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.item[key]).format('YYYY/MM/DD HH:mm:ss'));
        } else if (key.toString().endsWith('Id')) {
          if (this.state.item[key] && this.state.item[key].id && this.state.item[key].id > 0)
            data.append(key, this.state.item[key].id)
          else if (this.state.item[key] && this.state.item[key] > 0)
            data.append(key, this.state.item[key])
        } else {
          data.append(key, this.state.item[key]);
        }
      }

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      Api.post('/organizationaccountemails', data, config)

        .then(result => {
          if (result.data.success) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({ id: "add.success" }),
              item: this.initialState,
              files: []
            });


          }
          else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result.data && result.data.errors ? result.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })

            });
            Api.kickoff(result);
          }

        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
          }
          else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
          }
          Api.kickoff(err);
        });
    }
  };


  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));

    this.setState({ loading: false });
  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  testSendMail = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    if (this.state.item.passwordSend != '' && this.state.item.serverSend != '' && this.state.item.portSend != '' && this.state.item.userSend != '' && this.state.item.emailtest != '' && this.state.item.fromMailSend != '') {
      var data = {
        idSend: null,
        serverSend: this.state.item.serverSend,
        fromMailSend: this.state.item.fromMailSend,
        portSend: this.state.item.portSend,
        passwordSend: this.state.item.passwordSend != null ? this.state.item.passwordSend : null,
        userSend: this.state.item.userSend,
        addressemail: this.state.item.emailtest,
      }

      await Api.post('/emails/testSend', data)
        .then(result => {
          if (result && result.data && result.data.success == true) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "success",
              notificationMessage: intl.formatMessage({ id: "email.sent" })
            });
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "error.verify.sending.info" })
            });
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "error.verify.sending.info" })
          });
          Api.kickoff(err);
        });

    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "insert.sending.info" }),
      })
    }
  }

  testReceivedMail = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    if (this.state.item.passwordReceived != '' && this.state.item.serverReceived != '' && this.state.item.portReceived != '' && this.state.item.userReceived != '' && this.state.item.fromMailReceived != '') {
      var data = {
        idReceived: null,
        serverReceived: this.state.item.serverReceived,
        portReceived: this.state.item.portReceived,
        passwordReceived: this.state.item.passwordReceived != null ? this.state.item.passwordReceived : null,
        fromMailReceived: this.state.item.fromMailReceived,
        userReceived: this.state.item.userReceived,
      }

      await Api.post('/emails/testReceived', data)
        .then(result => {
          if (result && result.data && result.data.success == true) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "success",
              notificationMessage: intl.formatMessage({ id: "mailbox.read.success.first.half" }) + result.data.data + intl.formatMessage({ id: "mailbox.read.success.second.half" })
            });
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
            });
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
          });
          Api.kickoff(err);
        });

    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "insert.receiving.info" }),
      })
    }
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { item, CryptoList, AuthTypeList, CloudTypeList, OrgList } = this.state;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='xl' style={{ paddingLeft: '10%', paddingRight: '10%', marginLeft: 0 }}>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button variant='outlined' color='primary' onClick={() => {
                    this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 14 }) : browserHistory.goBack()
                  }
                  }>{this.props.intl.formatMessage({ id: "back" })}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {intl.formatMessage({ id: "typography.add.item" })}
              </Typography>
              <ProviderSelection setCustomProvider={this.setCustomProvider} selected={this.state.customProvider} />
              {this.state.customProvider == 3 &&
                <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                  <RTabs selectedIndex={this.state.rTabIndex} onSelect={index => this.setRTabIndex(index)} >
                    <RTabList style={{ borderColor: '#BB8FCE' }}>
                      <RTab>{intl.formatMessage({ id: "sending.info" })}</RTab>
                      <RTab>{intl.formatMessage({ id: "reveiving.info" })}</RTab>
                    </RTabList>
                    <RTabPanel>
                      <MailSending
                        intl={intl}
                        item={item}
                        handleInputChange={this.handleInputChange}
                        changeValues={this.changeValues}
                        testSendMail={this.testSendMail}
                        AuthTypeList={AuthTypeList}
                        CryptoList={CryptoList}
                        CloudTypeList={CloudTypeList}
                      />
                    </RTabPanel>
                    <RTabPanel>
                      <MailReceiving
                        intl={intl}
                        item={item}
                        handleInputChange={this.handleInputChange}
                        changeValues={this.changeValues}
                        handelSelect={this.handelSelect}
                        testReceivedMail={this.testReceivedMail}
                        AuthTypeList={AuthTypeList}
                        CryptoList={CryptoList}
                        CloudTypeList={CloudTypeList}
                        OrgsList={OrgList}
                      />
                    </RTabPanel>
                  </RTabs>
                  <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                    <Grid item xs={12} sm={4} align-items-xs-center={'true'} justify-xs-flex-end={'true'}>
                      <Button
                        type='submit'
                        fullWidth
                        variant='contained'
                        color='primary'
                        className={classes.submit}
                      >
                        {this.props.intl.formatMessage({ id: "save" })}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              }
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
      </div>
    );
  }
}
OrganizationAccountEmailRegistration.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  organizations: state.organizations,
  configs: state.configs,
});
export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(OrganizationAccountEmailRegistration)));
